<template>
  <LayoutDefault>
    <div class="text">
      <div class="text__container container">
        <h2>KONTAKT</h2>


        <p>
            POLANDGROUPS Sp. z o.o.
            NIP: 1132910509
        </p>

        <p>
            Adres:
            Biuro aleja Krakowska 121, Warszawa
        </p>

        <p>
            Telefon:
            +48 884 074 848
        </p>

        <p>
            E-mail:
            sufitypolandgroup@gmail.com
        </p>
        </div>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from '@/layouts/LayoutDefault'
export default {
  components: { LayoutDefault, }
}
</script>